import React, {useState, useEffect} from "react";
import parse from 'html-react-parser';
import Skeleton from 'react-loading-skeleton';
import BlogListings from "./BlogListings"; 

import 'assets/css/quill.snow.min.css'; 

import noimage from 'assets/images/csango10-13kerulet-elado-lakasok-3.webp';

import clg from "functions/log";
import req from "functions/req"; 
import settings from "configs/settings";

const BlogSingle = ({slug, setHelmet = null}) => {


    const [loaded, setLoaded] = useState(false);

    const [blogData, setBlogData] = useState({
        description : null,
        timestamp : null,
        image : null,
        summary : null,
        title : null,
    });

    const get = () => {
        req( {method : "POST", url : settings.req.blog.get_entries, data : { draft : 0, slug : slug }} ).then(function(res){
            clg( "blog single res: ", res );
            if( res && res.success ) {
                const data = res.data[0]; 

                setBlogData({
                    ...blogData,
                    description : data.content,
                    timestamp : data.date,
                    title : data.title,
                    summary : data.summary,
                    image : data.image,
                });

                if( setHelmet && typeof setHelmet === "function" ) {
                    setHelmet({
                        title : data.title,
                        meta : ( res.hasOwnProperty("meta") ? res.meta : null )
                    })
                }

                setLoaded(true);
            }
        });
    }

    useEffect(() => {
        get();
    },[]);

    return(
        <>

        <div className="container-fluid blog-header">
            <div className="blog-header-background">

                {
                    loaded && (
                        <img src={blogData.image || noimage} alt={blogData.title} />
                    )
                }

                {
                    !loaded && (
                        <Skeleton height="100%"/>
                    )
                }
                
            </div>

            {
                loaded && (
                    <img className={`blog-header-img`} alt={blogData.title} src={blogData.image || noimage}/>
                )
            }
            
            <div className="container">
                {
                    loaded && (
                        <>
                        <div className="blog-header-title">{blogData.title}</div>
                        <div className="blog-header-timestamp">{blogData.timestamp}</div>
                        </>
                    )
                }
                
            </div>
        </div>

        <div className="container blog-container  pb-100">
            <div className="row justify-content-center">

                <div className="col-lg-8 blog-content">
                    <div className="row">
                        <div className="col-12 blog-title">{blogData.title || <Skeleton width={"80%"} height="22px"/>}</div>
                        <div className="col-12 blog-summary">{blogData.summary || <><Skeleton width="100%"/><Skeleton width="60%"/></>}</div>
                    </div>
                    <div className="row ">
                        <div className="col-12 p-0 ql-editor">
                            { (blogData.description ? parse(blogData.description) : <Skeleton count={30}/>) }
                        </div>
                    </div>
                </div>

                <div className="col-lg-4 blog-latest">
                    <div className="row">
                        <div className="col-12 blog-title">További híreink</div>
                    </div>

                    <div className="row">
                        <BlogListings blogListItemClasses={"col-12 theme-side"}/>
                    </div>
                </div>

            </div>
        </div>

        </>
    )
}

export default BlogSingle;